import StorageIcon from '@material-ui/icons/Storage';
import { SidebarItem } from '@backstage/core-components';
import { configApiRef, useApi } from '@backstage/core-plugin-api';
import { buildResourceExplorerTo } from './buildResourceExplorerTo';

/**
 * Sidebar entry that opens the resource explorer with optional default owner
 * filters from `app.resourceExplorer.defaultOwnerRefs` in app-config.
 *
 * @returns Sidebar row element
 */
export function ResourceExplorerSidebarItem() {
  const configApi = useApi(configApiRef);
  const explorerConfig = configApi.getOptionalConfig('app.resourceExplorer');
  const ownerRefs = explorerConfig?.getOptionalStringArray('defaultOwnerRefs') ?? [];
  const sidebarTitle =
    explorerConfig?.getOptionalString('sidebarTitle') ?? 'Resources';

  return (
    <SidebarItem
      icon={StorageIcon}
      to={buildResourceExplorerTo(ownerRefs)}
      text={sidebarTitle}
    />
  );
}
